export function formatNewsletterDate(value) {
  if (!value) return "Never";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Never";
  return date.toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function getLatestAudienceSync(drafts) {
  return [...(Array.isArray(drafts) ? drafts : [])]
    .filter((item) => item?.last_synced_audience_at)
    .sort(
      (a, b) =>
        new Date(b.last_synced_audience_at).getTime() -
        new Date(a.last_synced_audience_at).getTime(),
    )[0];
}
